import { FormattedMessage } from "react-intl";

import {
  RadioGroupBase,
  type RadioOption,
} from "@/common/components/forms/radio-group/RadioGroup";

import {
  CZECH_COUNTRY_CODE,
  IMPORT_TYPES,
  type ImportType,
} from "./farmImport.schema";

type Props = {
  countryCode: string;
  value: ImportType;
  onChange: (importType: ImportType) => void;
};

const ImportTypeSelector = ({
  countryCode,
  onChange,
  value,
}: Props): React.ReactElement => {
  const eagriOption: RadioOption<ImportType>[] =
    countryCode === CZECH_COUNTRY_CODE
      ? [
          {
            "data-testid": "radio-eagri",
            label: <FormattedMessage id="FarmImport.typesDescription.eagri" />,
            value: IMPORT_TYPES.EAGRI,
          },
        ]
      : [];

  const options: RadioOption<ImportType>[] = [
    ...eagriOption,
    {
      "data-testid": "radio-shapefile",
      label: <FormattedMessage id="FarmImport.typesDescription.shapefile" />,
      value: IMPORT_TYPES.SHAPEFILE,
    },
    {
      "data-testid": "radio-manual",
      label: <FormattedMessage id="FarmImport.typesDescription.manual" />,
      value: IMPORT_TYPES.MANUAL,
    },
  ];

  return (
    <RadioGroupBase<ImportType>
      name="importType"
      onChange={onChange}
      options={options}
      value={value}
    />
  );
};

export { ImportTypeSelector };
